import { render, staticRenderFns } from "./OrganizersStartSection.vue?vue&type=template&id=5733d438&"
import script from "./OrganizersStartSection.vue?vue&type=script&lang=js&"
export * from "./OrganizersStartSection.vue?vue&type=script&lang=js&"
import style0 from "./OrganizersStartSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports